export const getSentryIssueLink = (eventId: string) => {
  return `https://opensea.sentry.io/issues?query=${eventId}`
}

const sentryEventIdSymbol: unique symbol = Symbol("sentry_event_id")

declare global {
  interface Error {
    [sentryEventIdSymbol]?: string
  }
}

export function attachEventId(error: Error, eventId: string) {
  error[sentryEventIdSymbol] = eventId
}

export function readEventId(error: Error): string | undefined {
  return error[sentryEventIdSymbol]
}
